// @core/api/endpoints/activity/list_mapping_configs.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListMappingConfigsResponse,
} from '../../../types/activity';

const BASE_PATH = '/activity';

/**
 * List activity mapping configs
 * Returns all configured Kafka topic → Activity mappings.
 */
export async function ListMappingConfigs(
  params?: {
    limit?: string | number | boolean;
    cursor?: string | number | boolean;
    direction?: string | number | boolean;
    sort?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ListMappingConfigsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/activity-mappings`;
  const requestOptions = options;
  return client.get<ListMappingConfigsResponse>(requestPath, { ...requestOptions, params });
}
